import { Component, OnInit, Input } from '@angular/core';
import { ThemingService } from 'src/app/theming.service';
import { AppComponent } from 'src/app/app.component';
import { DatePipe } from '@angular/common';
import { LambdaService } from 'src/app/lambda.service';

@Component({
  selector: 'app-gift-cards-item',
  templateUrl: './gift-cards-item.component.html',
  styleUrls: ['./gift-cards-item.component.scss']
})
export class GiftCardsItemComponent implements OnInit {

  @Input() giftCardId!: string;  // Recibe el ID de la tarjeta de regalo del componente padre
  giftCardDetails: any;
  giftCard: any = {};
  giftCardTypeId: number = 0;
  giftCards: any[] = [];
  loading: boolean = false;

  constructor(
    public appComponent: AppComponent,
    private themingService: ThemingService,
    private lambdaService: LambdaService
  ) { }

  formatDate(date: string | Date): string {
    const datePipe = new DatePipe('en-US');
    return datePipe.transform(date, 'yyyy-MM-dd HH:mm') || '';
  }

  parseAmount(amount: string): number {
    return parseFloat(amount);
  }

  ngOnInit(): void {
    // Utiliza el ID pasado a través del @Input() para obtener los detalles de la tarjeta de regalo
    if (this.giftCardId) {
      this.getGiftCardItemsById(this.giftCardId);
    }
  }

 async getGiftCardItemsById(giftCardId: string): Promise<void> {
  this.loading = true;
  try {
    const response: any = await this.lambdaService.getGiftCardItemsById(
      parseInt(giftCardId),
      this.themingService.shopId
    );
    if (Array.isArray(response.giftCard)) {
      this.giftCard = response.giftCard[0];
    } else {
      console.error('Formato inesperado en la respuesta:', response);
    }
  } catch (error) {
    console.error('Error en la llamada a la API', error);
  } finally {
    this.loading = false;
  }
}

}
